import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

// вместо success выводится либо qrLink, либо qrCode
export type TQrFetchingResult = 'error' | 'none'

export type TSetQrFetchingResult = IAction<ETicketPayment.SET_QR_FETCHING_RESULT, TQrFetchingResult>

const setQrFetchingResult = (result: TQrFetchingResult): TSetQrFetchingResult => ({
    type: ETicketPayment.SET_QR_FETCHING_RESULT,
    payload: result,
});

export default setQrFetchingResult;
